import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "st-style p-text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Total", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Please choose any of the action below :", -1)
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "p-dialog-titlebar p-dialog-titlebar-icon" }, " Receipt Payments ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_14 = {
  key: 0,
  class: "popup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_PosPreviewReceipt = _resolveComponent("PosPreviewReceipt")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.itemFilter.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemFilter.type) = $event)),
              options: _ctx.receiptTypes,
              optionLabel: "key",
              optionValue: "value",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.itemFilter.keyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemFilter.keyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Receipt No"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search ",
              class: "p-button-primary p-mr-1",
              onClick: _ctx.loadSearchData
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-calendar",
              class: "p-button-warning",
              onClick: _ctx.openFilterDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-times ",
              class: "p-button-info p-mr-1",
              onClick: _ctx.cleanSearchData
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("b", null, _toDisplayString(_ctx.statement), 1)
      ]),
      _createVNode(_component_DataTable, {
        first: _ctx.goToFirstLink,
        "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
        firstModifiers: { sync: true },
        value: _ctx.lists,
        lazy: true,
        paginator: _ctx.checkPagination,
        rows: _ctx.limit,
        totalRecords: _ctx.totalRecords,
        scrollable: true,
        onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "Receipt Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.receipt_date)), 1)
            ]),
            footer: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "receipt_no",
            header: "Receipt No"
          }),
          _createVNode(_component_Column, { header: "Account Title" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.temp_customer_name ? slotProps.data.temp_customer_name : slotProps.data.profile_name.profileName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Total Amount" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.data.total_bill), 1)
            ]),
            footer: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(this.totalAmountAllRecords).toFixed(2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Balance" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                _ctx.calculateBalance(
                                    slotProps.data.total_bill,
                                    slotProps.data.receipt_balance
                                )
                            )), 1)
            ]),
            footer: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(this.totalBalanceAllRecords).toFixed(2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "description",
            header: "Description"
          }),
          _createVNode(_component_Column, {
            field: "user_name.userName",
            header: "Created By"
          }),
          _createVNode(_component_Column, { header: "Store Name" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.branch.branchName) + " ( " + _toDisplayString(slotProps.data.branch.branchCode) + " ) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-cog",
                class: "p-button-primary",
                onClick: ($event: any) => (_ctx.openMenu(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["first", "value", "paginator", "rows", "totalRecords"]),
      _createVNode(_component_Sidebar, {
        visible: _ctx.menuBar,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.menuBar) = $event)),
        position: "bottom",
        class: "p-sidebar-sm"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (!(_ctx.itemFilter.type == 'PUR' || _ctx.itemFilter.type == 'RPU' || _ctx.itemFilter.type == 'RFD'))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-print",
                    label: "PRINT POS RECEIPT",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printReceipt())),
                    class: "p-button-primary p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              (_ctx.itemFilter.type == 'RFD')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "pi pi-print",
                    label: "PRINT REFUND RECEIPT",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printReceipt())),
                    class: "p-button-primary p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                icon: "pi pi-print",
                label: "VIEW RECEIPT",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.previewDialog())),
                class: "p-button-primary p-button-md p-mx-2"
              }),
              (
                                _ctx.itemFilter.type != 'ASR' &&
                                    _ctx.totalBalanceReceipt > 0.02
                            )
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    icon: "pi pi-money-bill",
                    label: "PAY/RECEIVE PAYMENT",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openPaymentScreen())),
                    class: "p-button-success p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                icon: "pi pi-chart-bar",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openTransactionDialog())),
                label: "PAYMENT HISTORY",
                class: "p-button-warning p-button-md p-mx-2"
              }),
              (_ctx.item.type == 'TRN' && _ctx.item.status == 'Active')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.stockLeft())),
                    icon: "pi pi-shopping-cart",
                    label: "LEAVE STOCK",
                    class: "p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              (
                                _ctx.itemFilter.type == 'ASR' &&
                                    _ctx.item.status == 'Stock Left'
                            )
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 4,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveStock())),
                    icon: "pi pi-check-circle",
                    label: "SAVE STOCK",
                    class: "p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.previewTransactionDialog,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.previewTransactionDialog) = $event)),
        style: { width: '100vw' },
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized"
      }, {
        header: _withCtx(() => [
          _hoisted_12
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.selectedReceiptData.paymentTransactions,
            scrollable: true,
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
          }, {
            empty: _withCtx(() => [
              _hoisted_13
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Transaction Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.createdAt)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "sourceType",
                header: "Type"
              }),
              _createVNode(_component_Column, { header: "Receipt No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.receiptNo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "paymentType",
                header: "Payment Type"
              }),
              _createVNode(_component_Column, { header: "Paid Amount" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.transTotalAmount).toFixed(2)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "accountNo",
                header: "Reference"
              }),
              _createVNode(_component_Column, {
                field: "description",
                header: "Description"
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_SearchFilter, {
        searchDetail: {
                    status: this.filterDialog,
                    dialogTitle: this.dialogTitle,
                    scenario: this.scenario,
                    selectedDateFilter: this.selectedDateFilter,
                    supplierFilter: this.supplierFilter,
                    selectedSupplierID: this.itemFilter.supplierID
                },
        onUpdateFilterStatus: _ctx.updateFilterStatus
      }, null, 8, ["searchDetail", "onUpdateFilterStatus"]),
      _createVNode(_component_PosPreviewReceipt, {
        PreviewReceipt: {
                    status: this.previewPosReceipt,
                    dialogTitle: this.dialogTitle,
                    previewHeading: this.previewHeading,
                    receiptID: this.receiptID
                },
        onUpdatePreviewStatus: _ctx.updatePreviewStatus
      }, null, 8, ["PreviewReceipt", "onUpdatePreviewStatus"]),
      _createVNode(_component_PaymentScreen, {
        receiptDetail: {
                    dialogStatus: _ctx.paymentDialog,
                    itemSource: _ctx.item.type,
                    restriction: 'No',
                    paymentOptionType: 'Transaction',//his is for enable/disble payment option buttons
                    cashPayment:this.cashPaymentOption,
                    cardPayment:this.cardPaymentOption,
                    chequePayment:_ctx.chequePaymentOption,
                    payLater:this.payLaterOption,
                    dialogTitle: _ctx.dialogTitle,
                    customerID: this.item.profileID,
                    customerName: this.item.selectedProfile,
                    closeConfirmation: true,
                    latency: this.latency,
                    paySupplierCredit:_ctx.paySupplierCredit,
                    supplierCreditAmount:_ctx.supplierCreditAmount
                },
        onClosePaymentScreenEvent: _ctx.closePaymentScreen,
        onGetProceededPaymentsEvent: _ctx.getProceededPayments
      }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
      (_ctx.popupVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("p", null, "Scanned Text: " + _toDisplayString(_ctx.scannedText), 1),
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
            }, "OK")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}